import ListingContentNavigationWrapper from './ListingContentNavigation';

export default ListingContentNavigationWrapper;
